import React from "react";

export default class NavbarNotifications extends React.Component {
  render() {
    return <ul className="navbar-nav ml-auto">{this.props.children}</ul>;
  }
}
